import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { PasswordInput } from "@/components/ui/password-input";

import type { ResendConnectionFormValues } from "./resend-connection-schema";
import type { ResendConnection } from "@artisancode/api-types";
import type { UseFormReturn } from "react-hook-form";

export function ResendConnectionFields({
  form,
  editing,
}: {
  form: UseFormReturn<ResendConnectionFormValues>;
  editing: ResendConnection | null;
}) {
  return (
    <div className="grid gap-3">
      <FormField
        control={form.control}
        name="name"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Nama Koneksi</FormLabel>
            <FormControl>
              <Input placeholder="misal: Resend Utama" autoFocus {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="fromAddress"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Alamat Pengirim (From)</FormLabel>
            <FormControl>
              <Input
                type="email"
                placeholder="noreply@jamcoffee.id"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="apiKey"
        render={({ field }) => (
          <FormItem>
            <FormLabel>API Key</FormLabel>
            <FormControl>
              <PasswordInput
                placeholder={
                  editing?.hasApiKey
                    ? "•••••••••••• (biarkan kosong untuk tetap pakai yang lama)"
                    : "re_xxxxxxxxxxxxxxxx"
                }
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
